import React, { useEffect, useRef, useState } from "react";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { CardLayout } from "../CustomSubtopicCardLayout";
import { PriceLayoutRow } from "./PriceLayoutRow";
export const PriceLayoutCard = ({ title, subtitle, tooltip, initialSubtopics, originalSubtopics, baseCount, maxSubtopics, onAddedCountChange, onSubtopicsChange, saveTrigger, onEditingCountChange, showToggle, isToggled, onToggle, toggleTooltip, readOnly, hasBeenRun, }) => {
    var _a;
    const analytics = useAnalytics();
    const defaultCount = baseCount !== null && baseCount !== void 0 ? baseCount : initialSubtopics.length;
    const [subtopics, setSubtopics] = useState(initialSubtopics);
    // When omitted, the row count mirrors how many values the BE seeded for this card —
    // the card's structure should reflect what's actually defined upstream, not a hardcoded slot count.
    const omittedRowCount = (_a = originalSubtopics === null || originalSubtopics === void 0 ? void 0 : originalSubtopics.length) !== null && _a !== void 0 ? _a : subtopics.length;
    const displaySubtopics = isToggled
        ? subtopics
        : Array.from({ length: omittedRowCount }, (_, i) => { var _a; return (_a = subtopics[i]) !== null && _a !== void 0 ? _a : ""; });
    const addedCount = Math.max(0, subtopics.length - defaultCount);
    useEffect(() => {
        onAddedCountChange === null || onAddedCountChange === void 0 ? void 0 : onAddedCountChange(addedCount);
    }, [addedCount, onAddedCountChange]);
    useEffect(() => {
        onSubtopicsChange === null || onSubtopicsChange === void 0 ? void 0 : onSubtopicsChange(subtopics);
    }, [subtopics, onSubtopicsChange]);
    // When the user reactivates a previously omitted card, restore the seeded base values
    const prevToggledRef = useRef(isToggled);
    useEffect(() => {
        const wasOff = !prevToggledRef.current;
        prevToggledRef.current = isToggled;
        if (wasOff && isToggled && subtopics.length === 0 && (originalSubtopics === null || originalSubtopics === void 0 ? void 0 : originalSubtopics.length)) {
            setSubtopics(originalSubtopics);
        }
    }, [isToggled, subtopics.length, originalSubtopics]);
    const handleEdit = (index, newValue) => {
        const isDefault = index < defaultCount;
        if (!newValue && isDefault) {
            return;
        }
        analytics.track("Custom Subtopics | Subtopic Edited", { category: title, index, newValue });
        setSubtopics((prev) => prev.map((item, i) => (i === index ? newValue : item)));
    };
    return (React.createElement(CardLayout, { title: title, subtitle: subtitle, tooltip: tooltip, canAddMore: false, maxSubtopics: maxSubtopics, readOnly: readOnly, hasBeenRun: hasBeenRun, hideAddButton: true, showToggle: showToggle, isToggled: isToggled, onToggle: onToggle, toggleTooltip: toggleTooltip },
        React.createElement(PriceLayoutRow, { subtopics: displaySubtopics, defaultCount: defaultCount, onEdit: handleEdit, category: title, saveTrigger: saveTrigger, onEditingCountChange: onEditingCountChange, disabled: !isToggled, readOnly: readOnly, hasBeenRun: hasBeenRun })));
};
